<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">Logs de Boletos</span>
        <button class="fab-button primary" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
            <i class="pi pi-filter"></i>
        </button>
    </p-header>

    <form class="filters" (submit)="search()" appFilters>
        <div class="filter-row">
            <div class="form-control">
                <label>ID do Boleto</label>
                <input type="number" pInputText [(ngModel)]="billetId" name="billetId" placeholder="Digite o ID">
            </div>
            
            <div class="buttons">
                <div class="form-button">
                    <button type="submit" class="primary easymarine">Pesquisar</button>
                </div>
            </div>
        </div>
    </form>

    <div class="table">
        <p-table [value]="logs" [resizableColumns]="true" [paginator]="true" [rows]="10"
            [rowsPerPageOptions]="[10,20,30,50,100]" styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th>Data Alteração</th>
                    <th>Vencimento</th>
                    <th>Emissão</th>
                    <th>Identifier</th>
                    <th>Cliente ID</th>
                    <th>Fatura ID</th>
                    <th>Boleto ID</th>
                    <th>Status</th>
                    <th>Responsável</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-log>
                <tr>
                    <td [pTooltip]="log.changeDate" tooltipPosition="top">{{log.changeDate}}</td>
                    <td [pTooltip]="log.dueDate" tooltipPosition="top">{{log.dueDate}}</td>
                    <td [pTooltip]="log.issueDate" tooltipPosition="top">{{log.issueDate}}</td>
                    <td [pTooltip]="log.identifier" tooltipPosition="top">{{log.identifier}}</td>
                    <td [pTooltip]="log.customerId?.toString()" tooltipPosition="top">{{log.customerId}}</td>
                    <td [pTooltip]="log.invoiceId?.toString()" tooltipPosition="top">{{log.invoiceId}}</td>
                    <td [pTooltip]="log.billetId?.toString()" tooltipPosition="top">{{log.billetId}}</td>
                    <td [pTooltip]="log.status" tooltipPosition="top">{{log.status}}</td>
                    <td [pTooltip]="log.responsible" tooltipPosition="top">{{log.responsible}}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" style="text-align: center; padding: 3rem 1rem;">
                        <div class="empty-state" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px; width: 100%;">
                            <i class="pi pi-search" style="font-size: 4rem; color: #6c757d; margin-bottom: 1rem;"></i>
                            <p style="color: #6c757d; font-size: 1.1rem; margin: 0; max-width: 400px; text-align: center; line-height: 1.5;">
                                Adicione algum filtro, ou apenas clique em<br>Pesquisar para exibir os dados
                            </p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
